import type { ReactNode } from "react";
import { cn } from "./cn";

interface BadgeProps {
  children: ReactNode;
  /** Optional dot colour (hex), used for pipeline and channel chips. */
  color?: string;
  className?: string;
}

/** Lane's Badge, unchanged. */
export function Badge({ children, color, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
        "bg-surface-2 text-content",
        className,
      )}
    >
      {color ? (
        <span
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
      ) : null}
      {children}
    </span>
  );
}
